import React, { useContext } from 'react';

import Headline from '@components/atoms/headline/headline';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';

import { WishesContext } from '../../contexts/wishesProvider';

import StyledIntroduction from './introduction.style';

const Introduction = () => {
  const { introduction, showIntroduction, setShowIntroduction } = useContext(WishesContext);

  if (!showIntroduction) return null;

  return (
    <StyledIntroduction role="button" onClick={() => setShowIntroduction(false)}>
      <div className="introduction__content">
        {introduction.subline && (
          <Headline tag="span" secondary>
            {introduction.subline}
          </Headline>
        )}
        <Headline tag="h1">{introduction.headline}</Headline>
        <MixedCopy html={introduction.introCopy} focused fullWidth />
      </div>
    </StyledIntroduction>
  );
};

export default Introduction;
